import axios from 'axios';

const dingRequest = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: 5000,
});

export const sendDingMessage = (message: string, conversationId: string) => {
  const endpoint = 'credit/dingTalk/send-ding-message';
  const payload = {
    text: message,
    conversationId,
  };

  try {
    return dingRequest.post<any>(endpoint, payload);
  } catch (error) {
    console.error("Failed to send DingTalk message:", error);
    return Promise.resolve();
  }
}; 